import React, { Component } from 'react'

import api from "./api"

import PaperBlock from './ui/PaperBlock'
import Screen from "./ui/Screen.js"

import {Typography, TextField, Button} from '@material-ui/core'

import Logo from "./logo.png"

import ErrorMessageDialog from "./ErrorMessageDialog"
import RestorePasswordDialog from "./RestorePasswordDialog.js"
import SuccessRestorePasswordDialog from "./SuccessRestorePasswordDialog.js"

import withStyles from '@material-ui/core/styles/withStyles'


const styles = theme => ({
	screen: {
		marginTop: theme.spacing.unit * 2,
		display: 'flex',
	    flexDirection: 'column',
	    alignItems: 'center',
		padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
	    [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
	       width: 400,
	       marginLeft: 'auto',
	       marginRight: 'auto',
	    },
	},
	avatar: {
		margin: theme.spacing.unit,
		backgroundColor: theme.palette.secondary.main,
	},
	paper: {
		alignItems: "center",
		justifyContent: "center",
		flexDirection: "column",
		display: "flex",
		gap: "10px",
	},
})

/**
 * Экран входа.
 * 
 * successHandle(user)
 * registerHandle(user) * 
 */

class LoginScreen extends Component {

	constructor(props) {

		super(props)

		this.state = {
			name: this.props.name,
			password: this.props.password,
			ErrorMessageDialog: this.props.ErrorMessageDialog,
			dialog: undefined,
		}
	
		this.handle_onLoginClick = this.handle_onLoginClick.bind(this)
		this.handle_onRestorePasswordClick = this.handle_onRestorePasswordClick.bind(this)
		this.handle_error = this.handle_error.bind(this)

	}

	handle_error(error) {
        let message = error instanceof String ? error : error.message
		this.setState({
			dialog: <ErrorMessageDialog 
				message = {message}
				onClose = {() => this.setState({dialog: undefined})}
			/>
		})
	}

	handle_onLoginClick = (e) => {
		e.stopPropagation()
		api.auth.login(this.state.name, this.state.password)
			.then(response => {
				if (typeof this.props.successHandle === "function") {
					this.props.successHandle({
						sid: response.sid,
						name: this.state.name,
						password: this.state.password
					})					
				}
			})
			.catch(this.handle_error)
	}

	handle_onRestorePasswordClick = (e) => {
		e.stopPropagation()
		this.setState({dialog: <RestorePasswordDialog 
			onRestorePasswordClick = {user_name => api.auth.restorePassword(user_name)
				.then(() => this.setState({dialog: <SuccessRestorePasswordDialog 
					onCloseClick = {() => this.setState({dialog: undefined})}
				/>}))
				.catch(this.handle_error)
			}
			onCancelClick = {() => this.setState({dialog: undefined})}
		/>})
	}

	readyToLogin = () => this.state.name && this.state.password

	render() {

		const { classes } = this.props

		return <Screen>

			{this.state.dialog}

			<PaperBlock className={classes.paper}>

				<img src = {Logo} alt = "logo"/>

				<Typography component = "h1" variant = "h5">Вход</Typography>

                <TextField
					fullWidth
					variant='outlined'
					value = {this.state.name}
					label = "Имя пользователя"
					margin = "normal"
					onChange = {e => {
						e.preventDefault()
						this.setState({name: e.target.value})
					}}                    
                />

				<TextField
					fullWidth
					variant='outlined'
					value = {this.state.password}
					label = "Пароль"
					margin = "normal"
					type = "password"
					onChange = {e => {
						e.preventDefault()
						this.setState({password: e.target.value})
					}}                    
                />

				<Button
					fullWidth
					disabled = {!this.readyToLogin()}
					variant = "contained"
					color = "primary"
					onClick = {this.handle_onLoginClick}
				>Вход</Button>

				<Button
					fullWidth
					variant = "contained"
					onClick = {this.handle_onRestorePasswordClick}
				>Восстановить пароль</Button>

			</PaperBlock>

		</Screen>

	}

}

export default withStyles(styles)(LoginScreen)
